import { getChainConfigEntry } from '@/config/chain'
import { Token } from '../types/Token'
import { TokenSymbol } from '../types/TokenSymbol'
import { useChainId } from 'wagmi'

export function useDisplayToken(token: Token): Token {
  const chainId = useChainId()

  return getDisplayToken(chainId, token)
}

export function getDisplayToken(
  chainId: number,
  token: Token,
  { skipWrappedNative }: { skipWrappedNative?: boolean } = {},
): Token {
  const { tokenSymbolToReplacedName, nativeAssetInfo } = getChainConfigEntry(chainId).markets || {}

  if (!tokenSymbolToReplacedName || (skipWrappedNative && token.symbol === nativeAssetInfo?.wrappedNativeAssetSymbol)) {
    return token
  }

  return Object.keys(tokenSymbolToReplacedName).includes(token.symbol)
    ? token.clone({
        symbol: tokenSymbolToReplacedName[token.symbol]!.symbol,
        name: tokenSymbolToReplacedName[token.symbol]!.name,
      })
    : token
}

export function getCanonicalSymbol(chainId: number, symbol: TokenSymbol): TokenSymbol {
  const { tokenSymbolToReplacedName, nativeAssetInfo } = getChainConfigEntry(chainId).markets || {}

  if (!tokenSymbolToReplacedName || symbol === nativeAssetInfo?.nativeAssetSymbol) return symbol

  for (const [canonical, replacement] of Object.entries(tokenSymbolToReplacedName)) {
    if (replacement?.symbol === symbol) {
      return TokenSymbol(canonical)
    }
  }

  return symbol
}

export function getDisplayTokenSymbol(
  chainId: number,
  tokenSymbol: TokenSymbol,
  { skipWrappedNative }: { skipWrappedNative?: boolean } = {},
): TokenSymbol {
  const { tokenSymbolToReplacedName, nativeAssetInfo } = getChainConfigEntry(chainId).markets || {}

  if (!tokenSymbolToReplacedName || (skipWrappedNative && tokenSymbol === nativeAssetInfo?.wrappedNativeAssetSymbol)) {
    return tokenSymbol
  }

  return Object.keys(tokenSymbolToReplacedName).includes(tokenSymbol)
    ? tokenSymbolToReplacedName[tokenSymbol]!.symbol
    : tokenSymbol
}
